import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PEDIDO_PRAZO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PEDIDO_PRAZO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('pedidoPrazoForm', registro)
    ];
}

export function getLista(agenda) {
    const request = axios.get(`${consts.API_URL}/pedidoPrazo${agenda ? '?agenda=true' : ''}`);
    return {
        type: 'PEDIDO_PRAZO_LISTADO',
        payload: request
    };
}

export function initFormProspeccao(registro = {}) {
    return [
        initialize('prospeccaoForm', registro)
    ];
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pedidoPrazo`, {
				...registro,
				codigo: FormatUtils.formatarValorBanco(registro.codigo, 0),
				dias: FormatUtils.formatarValorBanco(registro.dias, 0),
				media: FormatUtils.formatarValorBanco(registro.media, 0),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/pedidoPrazo`, {
				...registro,
				codigo: FormatUtils.formatarValorBanco(registro.codigo, 0),
				dias: FormatUtils.formatarValorBanco(registro.dias, 0),
				media: FormatUtils.formatarValorBanco(registro.media, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoPrazo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
